module.exports = __webpack_public_path__ + "static/img/2.e61c4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/2.png
// module id = IAYN
// module chunks = 35